import { Dialog } from '@angular/cdk/dialog';
import { NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { UserInfoCard } from '@simOn/common/user-info-card-models';
import { BreakpointService } from '@simOn/ui/breakpoint';
import { SimTooltipComponent } from '@simOn/ui/sim-tooltip';
import { EventAssigneesDialogComponent } from '../assignees-dialog/event-assignees-dialog.component';
import { EventAvatarComponent } from '../event-avatar/event-avatar.component';

export const MAX_VISIBLE_ASSIGNEES = 3;

export type AvatarStackTrigger = 'click' | 'hover';

@Component({
  selector: 'sim-event-avatar-stack',
  imports: [NgTemplateOutlet, EventAvatarComponent, SimTooltipComponent],
  templateUrl: './event-avatar-stack.component.html',
  styleUrl: './event-avatar-stack.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class EventAvatarStackComponent {
  private readonly _breakpoint = inject(BreakpointService);
  private readonly _dialog = inject(Dialog);

  readonly assignees = input<UserInfoCard[]>([]);
  readonly size = input<number>(32);
  readonly max = input<number>(MAX_VISIBLE_ASSIGNEES);
  readonly trigger = input<AvatarStackTrigger>('click');

  protected readonly isMobile = toSignal(this._breakpoint.isMobile$, { initialValue: false });

  protected readonly visible = computed(() => (this.assignees() ?? []).slice(0, this.max()));
  protected readonly overflow = computed(() => {
    const total = this.assignees()?.length ?? 0;
    return total > this.max() ? total - this.max() : 0;
  });

  protected openDialog(event: Event): void {
    event.stopPropagation();
    this._dialog.open(EventAssigneesDialogComponent, {
      panelClass: ['overlay-background', 'cdk-dialog-mobile'],
      width: 'min(420px, 100%)',
      data: { assignees: this.assignees() ?? [] }
    });
  }
}
